import {useQuery} from "@tanstack/react-query";
import {MAIN_REJESTR_API_SHORT} from "../../../../components/utils/consts.js";
import {useSelector} from "react-redux";
import {getData} from "../../../app/getters/getData.js";


export const useHistoriaProjektu = (id, enabled = true) => {

    const role = useSelector(state => state.user.role) // to string
    const roleParam = (!role || role === 'oper') ? '' : role + '/';
    let endpoint;

    if (role === 'oper') {
        endpoint = `/oper/${MAIN_REJESTR_API_SHORT}/historia/${id}`;
    }else{
        endpoint = `/${MAIN_REJESTR_API_SHORT}/${roleParam}historia/${id}`;
    }

    return useQuery({
        queryKey: [`historia_zadania`, id],
        queryFn: () => getData(endpoint),
        enabled: enabled,
        refetchOnMount: true,
    })
}